<template>
  <section id="products" class="products-section">
    <div class="container">
      <div class="section-title">
        <div class="en-label">{{ $t('products.eyebrow') }}</div>
        <h2>{{ $t('products.title') }}</h2>
        <p>{{ $t('products.desc') }}</p>
      </div>

      <div class="architecture-board" :aria-label="$t('products.ariaLabel')">
        <div class="architecture-row" v-for="layer in layers" :key="layer.code">
          <div class="layer-label" :class="layer.theme">
            <span class="layer-code">{{ layer.code }}</span>
            <strong>{{ layer.name }}</strong>
            <em>{{ layer.en }}</em>
          </div>

          <div class="layer-modules" :style="{ gridTemplateColumns: `repeat(${layer.columns}, minmax(0, 1fr))` }">
            <div
              class="module-card"
              v-for="item in layer.items"
              :key="item.id"
              :class="layer.theme"
              :style="{ gridColumn: item.span ? `span ${item.span}` : 'span 1' }"
            >
              <strong>{{ item.title }}</strong>
              <em>{{ item.en }}</em>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const layerMeta = {
  application: { theme: 'application', columns: 4 },
  business: { theme: 'business', columns: 4 },
  ai: { theme: 'ai', columns: 3 },
  data: { theme: 'data', columns: 3 },
  foundation: { theme: 'foundation', columns: 4 }
}

const itemMeta = {
  domain: { span: 2 },
  orchestration: { span: 2 },
  security: { span: 2 },
  aiops: { span: 2 }
}

export default {
  name: 'ProductsSection',
  computed: {
    layers() {
      return this.$tm('products.layers').map(layer => ({
        ...layer,
        ...layerMeta[layer.id],
        items: layer.items.map(item => ({
          ...item,
          ...itemMeta[item.id]
        }))
      }))
    }
  }
}
</script>

<style lang="less" scoped>
.products-section {
  padding: 120px 0;
  background: #fff;
}

.architecture-board {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 28px 24px;
  background: #fff;
  border: 1px solid #e8eef5;
  box-shadow: 0 24px 70px rgba(10, 34, 56, .12);
}

.architecture-row {
  display: grid;
  grid-template-columns: 142px minmax(0, 1fr);
  gap: 14px;
}

.layer-label,
.module-card {
  min-height: 82px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.layer-label {
  border: 1px solid currentColor;
  background: #fff;
}

.layer-code {
  font-size: 11px;
  line-height: 1;
  opacity: .75;
  margin-bottom: 4px;
}

.layer-label strong {
  font-size: 18px;
  line-height: 1.25;
}

.layer-label em,
.module-card em {
  font-style: normal;
  font-size: 11px;
  line-height: 1.4;
  opacity: .68;
}

.layer-modules {
  display: grid;
  gap: 10px;
  min-width: 0;
}

.module-card {
  border: 1px solid currentColor;
  border-top-width: 3px;
  background: #fff;
  padding: 10px 14px;
}

.module-card strong {
  font-size: 16px;
  line-height: 1.35;
  margin-bottom: 6px;
}

.application {
  color: #b468ff;
  background-color: #fbf5ff;
}

.business {
  color: #ff8720;
  background-color: #fff8f0;
}

.ai {
  color: #22bfff;
  background-color: #f1fbff;
}

.data {
  color: #22d9c5;
  background-color: #effdfb;
}

.foundation {
  color: #ffc21c;
  background-color: #fffaf0;
}

@media (max-width: 900px) {
  .architecture-board {
    padding: 20px 16px;
  }

  .architecture-row {
    grid-template-columns: 1fr;
  }

  .layer-modules {
    grid-template-columns: 1fr !important;
  }

  .module-card {
    grid-column: span 1 !important;
  }
}

@media (max-width: 600px) {
  .products-section {
    padding: 88px 0;
  }

  .architecture-board {
    margin: 0 -4px;
    padding: 14px;
    gap: 12px;
  }

  .layer-label,
  .module-card {
    min-height: 70px;
  }

  .layer-label strong {
    font-size: 16px;
  }

  .module-card strong {
    font-size: 15px;
  }
}
</style>
